import http from '../../utils/http';
const rootUrl = '/api';
const dentalxUrl = '/dentalx/api';

const preference = {
	/**
	 * 设计偏好
	 * @returns
	 */
	productPreferenceList(params) {
		return http.get( `${dentalxUrl}/dentalxProductPreferenceList`, params, { errCode: '@shining3d/xl-design-order.apiErr.preference' });
	},
    /**
	 * 保存设计偏好
	 * @returns
	 */
	saveProductPreference(data) {
		return http.post( `${dentalxUrl}/dentalxSaveProductPreference`, data, { errCode: '@shining3d/xl-design-order.apiErr.preference' });
	},
    /**
	 * 获取扫描杆替换数据
	 * @returns
	 */
	dentalScanningRodSystemList(params) {
		return http.get( `${rootUrl}/dentalScanningRodSystemList`, params, { errCode: '@shining3d/xl-design-order.apiErr.preference' });
	},
	  /**
	 * 获取扫描杆模型列表公司
	 * @returns
	 */
	  dentalScanningRodSystemBrandList(params) {
		return http.get( `${rootUrl}/dentalScanningRodSystemBrandList`, params, { errCode: 'preference' });
	},
};
export default preference;
